import { Dropdown } from '@statsbomb/kitbag-components';
import { useAtom } from 'jotai';
import { PropTypes } from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { selectedSportAtom } from '../../atoms/selectedMetadata';
import { FOOTBALL_IDENTIFIER, NFL_IDENTIFIER } from '../Sport/Sport';

export function Sport({ size }) {
  const intl = useIntl();

  const [selectedSport, setSelectedSport] = useAtom(selectedSportAtom);

  const options = [
    {
      label: intl.formatMessage({
        defaultMessage: 'Football',
        id: '449a5',
      }),
      value: FOOTBALL_IDENTIFIER,
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'NFL/AMF',
        id: '6f64f',
      }),
      value: NFL_IDENTIFIER,
    },
  ];

  return (
    <Dropdown
      id="sport-select"
      label={intl.formatMessage({ defaultMessage: 'Sport', id: '96faa' })}
      labelPosition="top"
      onChange={(selected) => setSelectedSport(selected.value)}
      options={options}
      placeholder={intl.formatMessage({
        defaultMessage: 'Sport',
        id: '96faa',
      })}
      size={size}
      value={options.find((option) => option.value === selectedSport)}
      variant="secondary"
    />
  );
}

Sport.propTypes = {
  size: PropTypes.string,
};
Sport.defaultProps = {
  size: undefined,
};

export default { Sport };
